const normalizeLabelPart = (value) => value == null ? '' : String(value).trim();

export const formatRegisteredNumberLabel = (item) => {
	const id = normalizeLabelPart(item && item.id);
	const phoneNumber = normalizeLabelPart(item && item.phonenumber);
	const accountName = normalizeLabelPart(item && item.accountname);
	const accountId = normalizeLabelPart(item && item.accountid);
	const messageProviderId = Number(item && item.messageproviderid);

	if (messageProviderId === 2) {
		return [accountName, phoneNumber].filter(Boolean).join(' - ') || `#${id}`;
	}

	if (messageProviderId === 3 || messageProviderId === 4) {
		return [accountName, accountId].filter(Boolean).join(' - ') || phoneNumber || `#${id}`;
	}

	return phoneNumber || accountName || accountId || `#${id}`;
};
